import type { FC } from 'react';
import React, { useState, useEffect, useRef } from 'react';
import { Button, Layout } from 'antd';
import examStyle from './index.less';
import { WaterMark } from '@ant-design/pro-layout';
import "github-markdown-css/github-markdown.css";
import { examination, candidate } from '@/api/examinationApi';
import { useLocation } from "umi";
import RadioList from './components/RadioList';
import CodeResultList from './components/CodeResultList';
const { Header, Content } = Layout;
/** 题目布局 */
const ExanminationLayout: FC = () => {
  const [questionType, setQuestionType] = useState('radio');
  const { query } = useLocation() as unknown as Location & { query: Record<string, string> };
  const [radioProblems, setRadioProblems] = useState<API.radioProblemResult[]>([]);
  const [codeProblems, setCodeProblems] = useState<API.codeProblemResult[]>([]);
  const [candidateInfo, setCandidateInfo] = useState<API.candidateInfo>();
  const [examineeScore, setExamineeScore] = useState(0);
  const [allScore, setAllScore] = useState(100);

  useEffect(() => {
    /** 获取数据 */
    async function getdata() {
      const [resGetContentRadio, resGetContentCode, resCandidateInfo] = await Promise.all([
        examination.resultChoice({
          examId: query.exam_id,
        }),
        examination.resultCode({
          examId: query.exam_id,
        }),
        candidate.info({
          candidateId: query.candidate_id
        })
      ]);
      setCandidateInfo(resCandidateInfo.data);
      setRadioProblems(resGetContentRadio.data);
      if(resGetContentRadio.data.length === 0) {
        setQuestionType('code');
      }
      /** 编程题相关 */
      setCodeProblems(resGetContentCode.data.map(item => ({
        ...item,
        language: item.languageId
      })));

      /** 计算考生的得分 */
      const radioAllScore = resGetContentRadio.data.reduce((pre, current) => {
        return  pre + current.score;
      }, 0);
      const codeAllScore = resGetContentCode.data.reduce((pre, current) => {
        return  pre + current.score;
      }, 0);
      setExamineeScore(radioAllScore + codeAllScore);
    }
    getdata();
  }, [query]);

  /** 计算考生的分数 */
  const scoreCalculate = () => {
    if(query.score) {
      return `：${query.score}/${allScore}`;
    } else {
      return isNaN(examineeScore) ? '' : `：${examineeScore}/${allScore}`;
    }
  };


  return (
    //<Layout className={examStyle.layout}>
    <Layout className="ant-layout">
      <Header className={examStyle.header}>
        <div style={{ display: 'flex' }}>
          <div className={examStyle.logo}>
            <div className={examStyle.zijin}>子衿</div>
            <div className={examStyle.version}>v1.0-beta</div>
          </div>
          <div className={examStyle.user}>{candidateInfo?.candidateName} 的考试结果 {scoreCalculate()} </div>
        </div>
        <div className={examStyle.buttons}>
          {(questionType === 'code' && radioProblems.length > 0) && <Button type="primary" style={{ marginRight: '10px' }} onClick={() => { setQuestionType('radio'); }}>选择题</Button>}
          {(questionType === 'radio' && codeProblems.length > 0) && <Button type="primary" style={{ marginRight: '10px' }} onClick={() => { setQuestionType('code'); }}>编程题</Button>}
        </div>
      </Header>
      <Content className={examStyle.content}>
        <WaterMark
          content={candidateInfo?.candidateName}
          rotate={-25}
          fontColor="rgba(0,0,0,.15)"
          fontSize={16}
          zIndex={32}
          gapX={100}
          gapY={100}
        >
          {(questionType === 'radio' && radioProblems.length > 0) && <RadioList problems={radioProblems} />}
          {(codeProblems.length > 0) && <CodeResultList style={{display: questionType === 'code' ? 'block' : 'none'}} problems={codeProblems} />}
        </WaterMark>
      </Content>
    </Layout>
  );
};

export default ExanminationLayout;
